import { render, staticRenderFns } from "./LegalTexts.vue?vue&type=template&id=1dce5021&scoped=true&"
import script from "./LegalTexts.vue?vue&type=script&lang=js&"
export * from "./LegalTexts.vue?vue&type=script&lang=js&"
import style0 from "./LegalTexts.vue?vue&type=style&index=0&id=1dce5021&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dce5021",
  null
  
)

export default component.exports